<template>
	<div>
		<v-card class="ma-2 mb-4">
			<v-toolbar :color="color" dark>
				<v-toolbar-title>
					<v-icon class="mr-3">business</v-icon>
					Projekty
				</v-toolbar-title>
			</v-toolbar>
			<v-btn
				@click="openExportModal"
				color="accent"
				dark>
				<v-icon left>save</v-icon>
				Eksport projektów
			</v-btn>
			<v-alert :value="projects !== null && projects.length === 0" type="info">
				Nie ma żadnych projektów!
			</v-alert>
			<v-list two-line v-if="projects !== null">
				<template v-for="(project) in projects">
					<v-list-tile :key="project.id" avatar>
						<v-list-tile-avatar>
							<v-icon color="primary">business</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title v-html="getTileTitle(project)"></v-list-tile-title>
							<v-list-tile-sub-title v-html="getTileSubtitle(project)"></v-list-tile-sub-title>
							<v-list-tile-action-text><td>
              {{ getTileActionText(project) }}
            <v-tooltip bottom v-if="project.projectStatus == 'WITHDRAWN'">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                  left
                  style="margin-left: 5px"
                  >cancel</v-icon>
              </template>
              <span>
				{{ project.withdrawalCause }}
			</span>
            </v-tooltip>
            </td></v-list-tile-action-text>
						</v-list-tile-content>
						<v-list-tile-action
							v-if="(roles.isAdministrator() || roles.isLocalAdministrator() || (roles.isDepartmentEmployee() && secretary)) && !project.hideFromUser">
							<v-btn icon @click.stop="supervisorButtonClicked(project)">
								<egranty-icon-button
									:icon="getSupervisorIcon(project)"
									color="primary"
									:label="getDialogTitle(project)"
									for="projects-add-supervisor"
									id="projects-add-supervisor"
									@click="supervisorButtonClicked(project)"/>
							</v-btn>
						</v-list-tile-action>
						<v-list-tile-action
							v-if="(roles.isAdministrator() || roles.isLocalAdministrator() || (roles.isDepartmentEmployee() && secretary)) && !project.hideFromUser">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon

										@click="goToProjectPanel(project)">
										<v-icon v-on="on">
											business
										</v-icon>
									</v-btn>
								</template>
								<span>Panel projektu</span>
							</v-tooltip>
						</v-list-tile-action>
						<v-list-tile-action v-if="!project.hideFromUser">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="showProject(project)">
										<v-icon v-on="on">
											description
										</v-icon>
									</v-btn>
								</template>
								<span>Podgląd</span>
							</v-tooltip>
						</v-list-tile-action>
					</v-list-tile>
				</template>
			</v-list>
		</v-card>
		<v-dialog v-model="dialog" scrollable max-width="500px">
			<v-card>
				<v-toolbar color="primary" class="mb-2">
					<v-toolbar-title style="font-size: 24px; font-weight: 400">{{getDialogTitle(selectedProject)}}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="selectedUser = null; dialog = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<template v-if="supervisors.length > 0">
					<v-autocomplete
						clearable
						style="margin-left: 20px; margin-right: 20px;"
						v-model="selectedUser"
						label="Opiekun projektu"
						aria-label="supervisor name"
						for="projects-list-select-supervisor"
						id="projects-list-select-supervisor"
						:items="supervisors"
						item-text="fullName"
						return-object
					>
					</v-autocomplete>
				</template>
				<v-card-actions style="padding: 16px">
					<v-spacer></v-spacer>
					<v-btn text @click="assignSupervisorToSelectedProject(); dialog = false">
						Wybierz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<project-export-modal ref="exportModal" :search="search"/>
	</div>
</template>

<script>
	import {Project} from "@/api/generated/Project";
	import ProjectExportModal from "./../../project/components/ProjectExportModal";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";


	export default {
		name: "ProjectsList",
		components: {ProjectExportModal, EgrantyIconButton},

		data() {
			return {
				dialog: false,
				selectedProject: null,
				selectedUser: null,
				search: {},
			};
		},
		props: {
			projects: {type: Array, default: () => []},
			supervisors: {type: Array, default: () => []},
			contestId: String,
			color: {type: String, default: "amber"},
			secretary: Boolean,
		},

		methods: {

			openExportModal() {
				this.$refs.exportModal.openModal({}, this.contestId, 'ALL_BY_CONTEST');
			},

			getTileTitle(project) {
				return project.mainBidder.polishName + ": " + project.title;
			},
			getTileSubtitle(project) {
				let ret = "[" + project.projectCode + "] | ";
				if (project.supervisor === null) {
					return ret + "Nie przydzielono opiekuna";
				} else {
					return ret + "Opiekun: " + project.supervisor.name + " " + project.supervisor.surname;
				}
			},
			getTileActionText(project) {
				switch (project.projectStatus) {
					case "NEW":
						return "Nowy projekt: oczekuje na zatwierdzenie";
					case "APPROVED":
					case "REQUESTED_CHANGES":
					case "POST_CORRECTION_MAIN":
					case "CORRECTED":
					case "AGREEMENT_SIGNED":
						return "Projekt w trakcie realizacji";
					case "WITHDRAWN":
						return "Projekt anulowany";
					case "FINISHED":
						return "Projekt zakończony";
				}
			},
			supervisorButtonClicked(project) {
				this.dialog = true;
				this.selectedProject = project;
				this.selectedUser = this.selectedProject.supervisor;
			},
			assignSupervisorToSelectedProject() {
				this.selectedProject.supervisor = this.selectedUser;
				Project.postProjectSupervisor(this, this.selectedProject.id, this.selectedUser.id);
				this.selectedUser = null;
			},
			getDialogTitle(project) {
				if (project !== null && project.supervisor !== null) {
					return "Zmień opiekuna";
				} else {
					return "Wskaż opiekuna";
				}
			},
			getSupervisorIcon(project) {
				if (project !== null && project.supervisor !== null) {
					return "group_add";
				} else {
					return "person_add";
				}
			},

			goToProjectPanel(project) {
				this.$router.push("/app/".concat(project.contestId).concat("/project-panel/").concat(project.id));
			},

			showProject(project) {
				this.$router.openInNewTab("/view/project/".concat(project.id));
			},
		},
	};
</script>

<style scoped>

</style>
